
import React from 'react';
import { styled } from '@mui/material/styles';
import Header from './Header';
import Footer from './Footer';

const ToolbarSpacer = styled('div')(({ theme }) => ({
  ...theme.mixins.toolbar,
}));


const Layout = ({children}) => {
    const pages = [
        { 
          text: 'Home',  
          path: '/' 
        },
        { 
          text: 'Articles', 
          path: '/articles' 
        },
        { 
          text: 'About', 
          path: '/about' 
        },
        { 
          text: 'Visuals', 
          path: '/visuals' 
        },
        { 
          text: 'Contact Us', 
          path: '/contact' 
        },
      ];

  return (
    <div>
        <Header pages={pages}/>
          <ToolbarSpacer/>
          <ToolbarSpacer/>
          <ToolbarSpacer/>
        { children }
        <Footer />
    </div>
  )
}

export default Layout
